import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services/local/authentication.service';
import { ToasterService } from 'angular2-toaster';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    public user;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private toasterService: ToasterService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const currentUser = this.authenticationService.currentUserValue;
        if (!currentUser) {       
            this.router.navigate(['/usuarios/login']);
            return false;
        }
        
        this.user = currentUser.data.user; 

        let dados: any = route.data;
        if (dados !== undefined) {
            let claim = route.data['claim'];

            if (claim) {
                if (!this.user.claims) {
                    this.toasterService.pop('warning', 'Sinto muito : |', 'Você não tem permissão para acessar esse recurso...');
                    return false;
                }

                let userClaims = this.user.claims.some(x => x.type === claim.nome && x.value === claim.valor);
                if (!userClaims) {
                    this.toasterService.pop('warning', 'Sinto muito : |', 'Você não tem permissão para acessar esse recurso...');
                    return;
                }
            }
        }

        return true;
    }
}